export default "__VITE_ASSET__BsDJP_35__"